module.exports = __webpack_public_path__ + "static/media/chevron-square-up.9464c767.svg";